<script lang="ts">
  import Avatar from '../Avatar.svelte';
  import { Button } from '@/lib/components/ui/button';
  import { conversationLabel, otherParticipants } from './formatting';
  import type { Conversation } from './api';

  export let conversation: Conversation;
  export let currentUserId: number;
  export let showBackButton: boolean;
  export let onBack: () => void;

  $: participants = otherParticipants(conversation, currentUserId).slice(0, 3);
  $: label = conversationLabel(conversation, currentUserId);
</script>

<div class="flex h-14 shrink-0 items-center gap-3 border-b border-border px-4">
  {#if showBackButton}
    <Button variant="ghost" size="icon" class="mr-1 shrink-0 text-muted-foreground hover:text-foreground md:hidden" on:click={onBack} title="Back to conversations">
      <i class="fa-solid fa-arrow-left"></i>
    </Button>
  {/if}
  <div class="flex -space-x-2">
    {#each participants as user (user.id)}
      <div class="rounded-full ring-2 ring-card">
        <Avatar profile_photo={user.profile_photo} first_name={user.first_name} last_name={user.last_name} username={user.username} shape="circle" pad_right={false} />
      </div>
    {/each}
  </div>
  <div class="min-w-0 leading-tight">
    <div class="truncate font-semibold text-foreground">{label}</div>
    {#if conversation.type === 'group'}
      <div class="truncate text-xs text-muted-foreground">{conversation.participants.length} members</div>
    {/if}
  </div>
</div>
